import { AnaliseCredito } from "./report-data.model";

export enum ConsigBalanceSolicitationStatusEnum {
  AGUARDANDO_AUTORIZACAO_DO_CLIENTE = "AGUARDANDO_AUTORIZACAO_DO_CLIENTE",
  PENDENTE = "PENDENTE",
  EM_PROCESSAMENTO = "EM_PROCESSAMENTO",
  CONCLUIDO = "CONCLUIDO",
  MARGEM_JA_UTILIZADA = "MARGEM_JA_UTILIZADA",
  SEM_MARGEM_DISPONIVEL = "SEM_MARGEM_DISPONIVEL",
  ERRO_INESPERADO = "ERRO_INESPERADO",
  NENHUM_EMPREGADOR_ELEGIVEL = "NENHUM_EMPREGADOR_ELEGIVEL",
}

export type ConsigBalanceSolicitation = {
  id: string;
  cpf: string;
  nome_cliente: string;
  id_usuario: string;
  nome_usuario: string;
  id_corban: number;
  status: ConsigBalanceSolicitationStatusEnum;
  data_criacao: Date;
  termo_consentimento_url: string;
  nome_processadora: string;
  descricao: string;
};

interface RiskQualificationProducts { 
  id_qualificacao_risco: string;
  nome_qualificacao_risco: string;
  produtos: Array<{ nome: string; parcelas: number; taxa_mensal: number }>
}

export interface BalanceSolicitationAnalysisResponse {
  dados_pessoais: {
    id: string;
    nome: string | null;
    cpf: string;
    data_nascimento: Date | null;
    idade: number | null;
    email?: string | null;
    telefone?: string | null;
    estado_civil?: string | null;
    nacionalidade?: string | null;
    genero?: string | null;
  };
  vinculos_empregaticios: Array<{
    id: string;
    empregador: {
      id: string;
      nome?: string;
      cnpj?: string;
    };
    data_admissao: Date | null;
    descricao_cbo?: string;
    margem: number;
    motivo_rejeicao?: string | null;
    margem_disponivel: number;
    total_dividas_cpf?: number | string;
    total_vencimentos?: number | string;
    qtd_emprestimos_ativos_suspensos?: number;
    qualificacao_risco: RiskQualificationProducts[];
    analise_credito?: AnaliseCredito | null;
    relatorios: Array<{
      id: string;
      aprovado: boolean;
      nome_motor?: string | null;
      descricao_motor?: string | null;
      tipo: string;
      rotulo?: string;
      pontuacao?: number;
      classificacao?: string;
      data_criacao: Date;
      motivo_rejeicao?: string | null;
      cnpj_pre_aprovado_id: string;
      criterios: Array<{
        id_criterio: string;
        nome_criterio: string;
        aprovado?: boolean;
        mensagem?: string;
        valor_original: any;
      }>;
    }>;
  }>;
}
